/**
 * LE BANDEAU HORS LIGNE (§14).
 *
 * Il dit trois choses, et pas une de plus : que le serveur n'est pas joignable, que **rien n'a été
 * joué** — c'est la seule qui compte dans un jeu où l'on ne meurt qu'une fois —, et que ce qui est
 * à l'écran reste là.
 *
 * IL NE PROPOSE PAS DE RÉESSAYER. Le prochain appel qui aboutit l'efface tout seul, et le
 * navigateur qui retrouve le réseau le lève aussitôt ; un bouton « réessayer » ne ferait que
 * demander au joueur de faire à la main ce que le code fait déjà, à l'instant précis où il n'a
 * envie de rien.
 *
 * Il vit SOUS l'enseigne et non par-dessus la page : une panne de réseau n'est pas une modale, on
 * continue de lire pendant qu'elle dure.
 */
import { t } from "../lexique/langue.js";
import { useEnLigne } from "../reseau.js";
import { Glyphe } from "./Glyphe.js";

export function BandeauHorsLigne() {
  const enLigne = useEnLigne();
  if (enLigne) return null;

  return (
    <p className="horsligne" role="status">
      <Glyphe nom="verrou" taille={14} />
      <span>
        <strong>{t("Hors ligne.")}</strong>{" "}
        {t(
          "Rien n'a été joué : ce qui est à l'écran vous reste, et les gestes qui écrivent attendent le retour de la connexion."
        )}
      </span>
    </p>
  );
}
